var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-form",
    { ref: "form", staticClass: "update-form" },
    [
      _c(
        "v-container",
        { attrs: { "grid-list-lg": "", fluid: "" } },
        [
          _c(
            "v-layout",
            { attrs: { wrap: "" } },
            [
              _vm.$project === "hwy"
                ? [
                    _c(
                      "v-flex",
                      { attrs: { xs12: "", "py-0": "" } },
                      [
                        _c(
                          "div",
                          { staticClass: "font-weight-bold pb-1 pl-1" },
                          [
                            _c("RequiredDot", [
                              _vm._v(_vm._s(_vm.$t("user.first_name"))),
                            ]),
                          ],
                          1
                        ),
                        _c("v-text-field", {
                          attrs: {
                            rules: [_vm.rules.required, _vm.rules.noNumOnly],
                            solo: "",
                            clearable: "",
                          },
                          model: {
                            value: _vm.formData.first_name,
                            callback: function ($$v) {
                              _vm.$set(_vm.formData, "first_name", $$v)
                            },
                            expression: "formData.first_name",
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                : [
                    _c(
                      "v-flex",
                      { attrs: { xs6: "", sm6: "", "py-0": "" } },
                      [
                        _c(
                          "div",
                          { staticClass: "font-weight-bold pb-1 pl-1" },
                          [
                            _c("RequiredDot", [
                              _vm._v(_vm._s(_vm.$t("user.first_name"))),
                            ]),
                          ],
                          1
                        ),
                        _c("v-text-field", {
                          attrs: {
                            rules: [_vm.rules.required, _vm.rules.noNumOnly],
                            solo: "",
                            clearable: "",
                          },
                          model: {
                            value: _vm.formData.first_name,
                            callback: function ($$v) {
                              _vm.$set(_vm.formData, "first_name", $$v)
                            },
                            expression: "formData.first_name",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-flex",
                      { attrs: { xs6: "", sm6: "", "py-0": "" } },
                      [
                        _c(
                          "div",
                          { staticClass: "font-weight-bold pb-1 pl-1" },
                          [
                            _c("RequiredDot", [
                              _vm._v(_vm._s(_vm.$t("user.last_name"))),
                            ]),
                          ],
                          1
                        ),
                        _c("v-text-field", {
                          attrs: {
                            rules: [_vm.rules.required, _vm.rules.noNumOnly],
                            solo: "",
                            clearable: "",
                          },
                          model: {
                            value: _vm.formData.last_name,
                            callback: function ($$v) {
                              _vm.$set(_vm.formData, "last_name", $$v)
                            },
                            expression: "formData.last_name",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
              _c(
                "v-flex",
                {
                  attrs: {
                    xs12: !_vm.requiredOnly,
                    xs6: _vm.requiredOnly,
                    sm6: "",
                    "py-0": "",
                  },
                },
                [
                  _c(
                    "div",
                    { staticClass: "font-weight-bold pb-1 pl-1" },
                    [
                      _c("RequiredDot", [
                        _vm._v(_vm._s(_vm.$t("user.country_region"))),
                      ]),
                    ],
                    1
                  ),
                  _c("v-autocomplete", {
                    attrs: {
                      items: _vm.countryList,
                      "item-text": "name",
                      rules: [_vm.rules.required],
                      solo: "",
                      "hide-no-data": "",
                    },
                    on: { change: _vm.changeCountry },
                    model: {
                      value: _vm.formData.country,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "country", $$v)
                      },
                      expression: "formData.country",
                    },
                  }),
                ],
                1
              ),
              !_vm.minimalForm || _vm.requiresState || _vm.additionalOpened
                ? _c(
                    "v-flex",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            !_vm.minimalForm ||
                            _vm.requiresState ||
                            _vm.expanded,
                          expression:
                            "!minimalForm || requiresState || expanded",
                        },
                      ],
                      class: {
                        "update-form__additional":
                          _vm.minimalForm && !_vm.requiresState,
                        "update-form__minimum-state":
                          _vm.minimalForm && _vm.requiresState && !_vm.expanded,
                      },
                      attrs: { xs6: "", sm6: "", "py-0": "" },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "font-weight-bold pb-1 pl-1" },
                        [
                          _c(
                            "RequiredDot",
                            {
                              attrs: {
                                required: !_vm.minimalForm || _vm.requiresState,
                              },
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(_vm.$t("user.state")) +
                                  "\n          "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c("v-autocomplete", {
                        attrs: {
                          disabled:
                            _vm.disabledState || this.stateList.length === 0,
                          items: _vm.stateList,
                          "item-text": "name",
                          rules:
                            !_vm.minimalForm || _vm.requiresState
                              ? [_vm.rules.required]
                              : [],
                          solo: "",
                          "hide-no-data": "",
                        },
                        model: {
                          value: _vm.formData.state,
                          callback: function ($$v) {
                            _vm.$set(_vm.formData, "state", $$v)
                          },
                          expression: "formData.state",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              !_vm.minimalForm || _vm.additionalOpened
                ? _c(
                    "v-flex",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.minimalForm || _vm.expanded,
                          expression: "!minimalForm || expanded",
                        },
                      ],
                      staticClass: "update-form__additional",
                      attrs: { xs6: "", sm6: "", "py-0": "" },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "font-weight-bold pb-1 pl-1" },
                        [
                          _c(
                            "RequiredDot",
                            { attrs: { required: !_vm.minimalForm } },
                            [_vm._v(_vm._s(_vm.$t("user.city")))]
                          ),
                        ],
                        1
                      ),
                      _c("v-text-field", {
                        attrs: {
                          solo: "",
                          rules: _vm.minimalForm
                            ? [_vm.rules.canNotHTMLTag]
                            : [_vm.rules.required, _vm.rules.canNotHTMLTag],
                          clearable: "",
                        },
                        model: {
                          value: _vm.formData.city,
                          callback: function ($$v) {
                            _vm.$set(_vm.formData, "city", $$v)
                          },
                          expression: "formData.city",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              !_vm.minimalForm || _vm.additionalOpened
                ? _c(
                    "v-flex",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.minimalForm || _vm.expanded,
                          expression: "!minimalForm || expanded",
                        },
                      ],
                      staticClass: "update-form__additional",
                      attrs: { xs12: "", sm6: "", "py-0": "" },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "font-weight-bold pb-1 pl-1" },
                        [
                          _c(
                            "RequiredDot",
                            { attrs: { required: !_vm.minimalForm } },
                            [_vm._v(_vm._s(_vm.$t("user.postcode")))]
                          ),
                        ],
                        1
                      ),
                      _c("v-text-field", {
                        attrs: {
                          rules: _vm.minimalForm
                            ? [_vm.rules.canNotHTMLTag]
                            : [_vm.rules.required, _vm.rules.canNotHTMLTag],
                          solo: "",
                          clearable: "",
                        },
                        model: {
                          value: _vm.formData.postcode,
                          callback: function ($$v) {
                            _vm.$set(_vm.formData, "postcode", $$v)
                          },
                          expression: "formData.postcode",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              !_vm.requiredOnly && (!_vm.minimalForm || _vm.additionalOpened)
                ? _c(
                    "v-flex",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.minimalForm || _vm.expanded,
                          expression: "!minimalForm || expanded",
                        },
                      ],
                      staticClass: "update-form__additional update-form__phone",
                      attrs: { xs12: "", sm6: "", "py-0": "" },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "font-weight-bold pb-1 pl-1" },
                        [
                          _c("RequiredDot", { attrs: { required: false } }, [
                            _vm._v(_vm._s(_vm.$t("user.phone_number"))),
                          ]),
                        ],
                        1
                      ),
                      _c("NumberInput", {
                        attrs: { solo: "", rules: [_vm.rules.canNotHTMLTag] },
                        model: {
                          value: _vm.formData.phone_number,
                          callback: function ($$v) {
                            _vm.$set(_vm.formData, "phone_number", $$v)
                          },
                          expression: "formData.phone_number",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              !_vm.minimalForm || _vm.additionalOpened
                ? _c(
                    "v-flex",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.minimalForm || _vm.expanded,
                          expression: "!minimalForm || expanded",
                        },
                      ],
                      staticClass: "update-form__additional",
                      attrs: { xs12: "", "py-0": "" },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "font-weight-bold pb-1 pl-1" },
                        [
                          _c(
                            "RequiredDot",
                            { attrs: { required: !_vm.minimalForm } },
                            [_vm._v(_vm._s(_vm.$t("user.address")))]
                          ),
                        ],
                        1
                      ),
                      _c("v-text-field", {
                        attrs: {
                          rules: _vm.minimalForm
                            ? [_vm.rules.canNotHTMLTag]
                            : [_vm.rules.required, _vm.rules.canNotHTMLTag],
                          solo: "",
                          clearable: "",
                        },
                        model: {
                          value: _vm.formData.address1,
                          callback: function ($$v) {
                            _vm.$set(_vm.formData, "address1", $$v)
                          },
                          expression: "formData.address1",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              !_vm.requiredOnly && (!_vm.minimalForm || _vm.additionalOpened)
                ? _c(
                    "v-flex",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.minimalForm || _vm.expanded,
                          expression: "!minimalForm || expanded",
                        },
                      ],
                      staticClass: "update-form__additional",
                      attrs: { xs12: "", "py-0": "" },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "font-weight-bold pb-1 pl-1" },
                        [
                          _c("RequiredDot", { attrs: { required: false } }, [
                            _vm._v(_vm._s(_vm.$t("user.address_2"))),
                          ]),
                        ],
                        1
                      ),
                      _c("v-text-field", {
                        attrs: {
                          rules: [_vm.rules.canNotHTMLTag],
                          solo: "",
                          clearable: "",
                        },
                        model: {
                          value: _vm.formData.address2,
                          callback: function ($$v) {
                            _vm.$set(_vm.formData, "address2", $$v)
                          },
                          expression: "formData.address2",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              !_vm.requiredOnly && (!_vm.minimalForm || _vm.additionalOpened)
                ? _c(
                    "v-flex",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.minimalForm || _vm.expanded,
                          expression: "!minimalForm || expanded",
                        },
                      ],
                      staticClass: "update-form__additional",
                      attrs: { xs12: "", "py-0": "" },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "font-weight-bold pb-1 pl-1" },
                        [
                          _c("RequiredDot", { attrs: { required: false } }, [
                            _vm._v(_vm._s(_vm.$t("user.company"))),
                          ]),
                        ],
                        1
                      ),
                      _c("v-text-field", {
                        attrs: {
                          solo: "",
                          clearable: "",
                          rules: [_vm.rules.canNotHTMLTag],
                        },
                        model: {
                          value: _vm.formData.company,
                          callback: function ($$v) {
                            _vm.$set(_vm.formData, "company", $$v)
                          },
                          expression: "formData.company",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            2
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }